import Vue      from 'vue'
import Carousel from 'vue-carousel/src/Carousel'
import Slide    from 'vue-carousel/src/Slide'

Vue.component('carousel', {
  extends: Carousel,
  methods: {
    onDrag() {
    },
    onStart() {
    },
    onEnd() {
    }
  }
})
Vue.component('slide', Slide)
